import { FormControl, InputLabel, TextField } from '@mui/material'
import { Dispatch, RefObject, useState } from 'react'
import { FormInput } from '../../../lib/workout-form/transformers'
import { Action, FormInputs } from '../../../reducers/workoutReducer'

type Props = {
  dispatch: Dispatch<Action>
  loading: boolean
  credits: FormInput
  handleErrorRefs: RefObject<(() => void)[]>
}

const CreditsInput = ({
  handleErrorRefs,
  dispatch,
  loading,
  credits,
}: Props) => {
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')
  const handleError = () => {
    setError(credits.error)
    setMessage(credits.message)
  }
  handleErrorRefs.current?.push(handleError)

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel
        sx={{ backgroundColor: 'white' }}
        htmlFor="body"
        error={false}
      />

      <TextField
        multiline
        id="credits"
        label="Credits"
        value={credits.input}
        inputProps={{
          style: { textAlign: 'center' },
        }}
        minRows={1}
        maxRows={1}
        onChange={(e) =>
          dispatch({ type: FormInputs.credits, payload: e.target.value })
        }
        disabled={loading}
        onBlur={handleError}
        error={error}
        helperText={message}
      />
    </FormControl>
  )
}

export default CreditsInput
